module.exports = __webpack_public_path__ + "static/img/portfolio4.c91fcfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/portfolio4.jpg
// module id = nTje
// module chunks = 0